import { JSXElement, mergeProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import '~/pages/ExternalPages/commons/styles/login-signup.scss';

type HostedAuthBoxContainerProps = {
  children: JSXElement;
  class?: string;
};

export default function HostedAuthBoxContainer(
  props: HostedAuthBoxContainerProps
): JSXElement {
  const merged = mergeProps(
    {
      class: ''
    },
    props
  );
  return (
    <div
      class={`min-h-screen w-full flex justify-center bg-login-canvas items-center`}
    >
      <div
        class={twMerge(
          `w-11/12 sm:w-[440px] my-10 flex flex-col items-center`,
          merged.class
        )}
      >
        {merged.children}
      </div>
    </div>
  );
}
